export const SEARCH_TYPES = {
  charter: "charter",
  hotel: "hotel",
  mkhotel: "mkhotel",
};
